import React, { useState, useEffect, useRef } from 'react';
import './Statistics.css';

export default function Statistics() {
    const [isVisible, setIsVisible] = useState(false);
    const statsRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.3 }
        );

        const currentRef = statsRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    const Counter = ({ end, duration, suffix = "" }) => {
        const [count, setCount] = useState(0);

        useEffect(() => {
            if (!isVisible) return;

            let startTime;
            let animationFrameId;
            
            const animate = (currentTime) => {
                if (!startTime) startTime = currentTime;
                const progress = Math.min((currentTime - startTime) / duration, 1);
                setCount(Math.floor(progress * end));

                if (progress < 1) {
                    animationFrameId = requestAnimationFrame(animate);
                }
            };

            animationFrameId = requestAnimationFrame(animate);
            
            return () => {
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId);
                }
            };
        }, [end, duration]);

        return <span>{count}{suffix}</span>;
    };

    const stats = [
        {
            icon: "🏆",
            number: 10,
            suffix: "+",
            label: "سنوات من الخبرة",
            duration: 2000
        },
        {
            icon: "😊",
            number: 300,
            suffix: "+",
            label: "عميل سعيد",
            duration: 2500
        },
        {
            icon: "✨",
            number: 20,
            suffix: "+",
            label: "خدمة متميزة",
            duration: 1800
        },
        {
            icon: "⭐",
            number: 98,
            suffix: "%",
            label: "نسبة الرضا",
            duration: 2200
        }
    ];

    return (
        <div className="statistics-section" ref={statsRef}>
            <div className="statistics-container">
                <div className="statistics-header">
                    <h2 className="statistics-title">إنجازاتنا بالأرقام</h2>
                    <p className="statistics-subtitle">نفخر بتقديم أفضل الخدمات وتحقيق رضا عملائنا</p>
                </div>
                
                <div className="statistics-grid">
                    {stats.map((stat, index) => (
                        <div key={index} className={`stat-card ${isVisible ? 'visible' : ''}`} style={{ animationDelay: `${index * 0.1}s` }}>
                            <div className="stat-icon">{stat.icon}</div>
                            <div className="stat-number">
                                <Counter end={stat.number} duration={stat.duration} suffix={stat.suffix} />
                            </div>
                            <div className="stat-label">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
